"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useHorizontalScroll = (onlyXScroll = true) => {
    const elRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const el = elRef.current;
        if (!el)
            return undefined;
        const onWheel = (e) => {
            if (e.deltaY === 0)
                return;
            const isOverflowing = el.scrollWidth > el.clientWidth;
            const isHorizontalScroll = !(el.scrollLeft === 0 && e.deltaY < 0) && !(el.scrollWidth - el.clientWidth - Math.round(el.scrollLeft) <= 0 && e.deltaY > 0);
            if ((onlyXScroll || isHorizontalScroll) && isOverflowing) {
                e.preventDefault();
                el.scrollTo({
                    left: el.scrollLeft + e.deltaY,
                });
            }
        };
        el.addEventListener('wheel', onWheel, { passive: true });
        return () => el.removeEventListener('wheel', onWheel);
    }, []);
    const centerElement = (index, smooth = true) => {
        const scrollList = elRef.current;
        const scrollListWidth = scrollList === null || scrollList === void 0 ? void 0 : scrollList.offsetWidth;
        const childEl = scrollList === null || scrollList === void 0 ? void 0 : scrollList.children[index];
        if (!childEl || !scrollList || !scrollListWidth)
            return;
        const childElWidth = childEl.offsetWidth;
        const childOffsetLeft = childEl.offsetLeft;
        scrollList.scrollTo(Object.assign({ left: childOffsetLeft + childElWidth / 2 - scrollListWidth / 2 }, (smooth && { behavior: 'smooth' })));
    };
    return { elRef, centerElement };
};
exports.default = useHorizontalScroll;
